import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

import { generateURL } from 'utilities/hooks/urlGeneration';
type Response = {
  url: string;
};
type StripeMutationVariables = {
  accountID: string | undefined;
  id: string;
  priceID: string;
};

export function useStripeCheckoutSession() {
  const addCheckoutSession = (checkoutSession: StripeMutationVariables) => {
    if (!checkoutSession.accountID) {
      return Promise.reject('Account ID can not be null');
    }

    const body = {
      ...checkoutSession,
      type: 'subscriptionCreditOptionChange',
    };
    const url = generateURL(SPARK_RESOURCE_TYPES.STRIPE_CHECKOUT_SESSION);
    return fetchWrapper<Response>({
      url: url,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addCheckoutSession', addCheckoutSession, {
    onSuccess: (data) => {
      if (data.url) {
        window.open(data.url, '_self');
      }
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to add checkout session: ${error.message}`);
      }
    },
  });
}
